const tipoChavePixToProp = {
  EMAIL: 'email',
  CPF: 'numeroDocumento',
  CNPJ: 'numeroDocumento',
  CELULAR: 'telefone',
}

export function handleChangeTipoChavePix({ value, record, setFieldFn }) {
  if (!setFieldFn || !value.id) {
    return
  }
  setFieldFn('tipoChavePix', value)
  const prop = tipoChavePixToProp[value.id]
  if (prop) {
    setFieldFn('chavePix', record[prop])
  }
}
